import React from "react";
import ModalShell from "./ModalShell";

// Hiring status change — a comment is mandatory and is saved as a note.
const StatusChangeModal = ({ fromName, toName, comment, onCommentChange, onClose, onConfirm, saving }) => (
  <ModalShell title="Change hiring status" maxWidth={460} onClose={onClose}>
    <div className="jv2-modal-body">
      <p style={{ textAlign: "left", fontSize: 13, color: "#525b66", margin: "0 0 12px" }}>
        You're moving this candidate from <strong>{fromName}</strong> to <strong>{toName}</strong>. Please add a quick note explaining the change — it will be saved as a note.
      </p>
      <label className="save-search-field-label">Comment <span style={{ color: "#f75891" }}>*</span></label>
      <textarea
        className="save-search-name-input"
        style={{ minHeight: 90, resize: "vertical", fontFamily: "inherit" }}
        placeholder="Add a comment explaining this change"
        value={comment}
        onChange={(e) => onCommentChange(e.target.value)}
        autoFocus
      />
    </div>
    <div className="jv2-modal-footer">
      <button className="jv2-modal-cancel" onClick={onClose}>Cancel</button>
      <button className="jv2-modal-confirm" disabled={!comment.trim() || saving} onClick={onConfirm}>
        {saving ? "Updating…" : "Update"}
      </button>
    </div>
  </ModalShell>
);

export default StatusChangeModal;
